import type { ReactPerformance } from "@/lib/react_performance"

export const isManagedState = <State>(
  state: State
): state is ReactPerformance.Managed<State> => {
  return (
    Boolean(state) &&
    typeof state === `object` &&
    typeof (state as unknown as Record<string, unknown>).update === `boolean`
  )
}
